import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../components/Admin/AdminLayout';
import axios from 'axios';

const AdminDashboard = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://infuse-backend.onrender.com/api/products')
      .then(res => res.json())
      .then(data => setProducts(data));
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure?")) return;

    await fetch(`https://infuse-backend.onrender.com/api/products/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });

    setProducts(prev => prev.filter(p => p._id !== id));
  };

  const handleToggleFeatured = async (id, featuredStatus) => {
    try {
      await axios.put(`https://infuse-backend.onrender.com/api/products/${id}`, { featured: featuredStatus }, { withCredentials: true });
      const updatedProducts = products.map(prod => 
        prod._id === id ? {...prod, featured: featuredStatus} : prod
      );
      setProducts(updatedProducts);
    } catch (err) {
      console.error('Error updating featured status:', err);
    }
  };

  return (
    <AdminLayout>
      <h2>All Products</h2>
      <table className="admin-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Featured</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map(prod => (
            <tr key={prod._id}>
              <td>{prod.name}</td>
              <td>{prod.category}</td>
              <td>
                <input 
                  type="checkbox" 
                  checked={prod.featured || false}
                  onChange={() => handleToggleFeatured(prod._id, !prod.featured)}
                />
              </td>
              <td>
                <img src={prod.image || 'placeholder-image-url'}  alt={prod.name} height="50" />
              </td>
              <td>
                <button className="btn-edit" onClick={() => navigate(`/admin/edit/${prod._id}`)}>Edit</button>
                <button className="btn-delete" onClick={() => handleDelete(prod._id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
};

export default AdminDashboard;